// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/anchor.js'; import './autoload/case-studies-slider.js'; import './autoload/case-team-slider.js'; import './autoload/certifications-slider.js'; import './autoload/faq-accordion.js'; import './autoload/home-hero-slider.js'; import './autoload/latest-posts-slider.js'; import './autoload/lazyload.js'; import './autoload/marquee.js'; import './autoload/menu.js'; import './autoload/our-team-video.js'; import './autoload/posts-listing.js'; import './autoload/services-accordion.js'; import './autoload/services-page.js'; import './autoload/showcase.js'; import './autoload/system-presentation.js'; import './autoload/tabs-logos.js'; import './autoload/testimonials-slider.js'; // eslint-disable-line

// Import local dependencies
import { scrollIntoViewWithOffset } from './utils/helpers';

import 'jquery-match-height';
import ScrollOut from 'scroll-out';

/**
 * Set CSS variable for header height
 */
const setHeaderHeight = () => {
  const header = document.querySelector('.header');

  if (header) {
    document.body.style.setProperty(
      '--header-height',
      `${header.offsetHeight}px`
    );
  }
};

const setCertificationsTitleHeight = () => {
  const titles = document.querySelectorAll('.certifications__item-title');

  if (!titles.length) {
    return;
  }

  titles.forEach((title) => {
    title.style.minHeight = '';
  });

  if (window.innerWidth < 1024) {
    return;
  }

  const maxHeight = Math.max(
    ...Array.from(titles).map((title) => title.offsetHeight)
  );

  titles.forEach((title) => {
    title.style.minHeight = `${maxHeight}px`;
  });
};

/**
 * Scripts which runs after DOM load
 */

$(document).ready(function () {
  /**
   * Detect element appearance in viewport
   */

  $('.matchHeight').matchHeight();

  ScrollOut({
    once: true,
    threshold: 0.4,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function (i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function () {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (_, formId) {
    let target = document.getElementById(
      `gform_confirmation_wrapper_${formId}`
    );

    if (target) {
      scrollIntoViewWithOffset(target, 100);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // Preloader
  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  // Create CSS variable for header height
  setHeaderHeight();

  // Match certification title heights on desktop
  setCertificationsTitleHeight();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // Create CSS variable for header height
  setHeaderHeight();

  // Match certification title heights on desktop
  setCertificationsTitleHeight();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});
